module.exports = __webpack_public_path__ + "static/media/Sero Image 1340 x 650.5b3704a6.png";